(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-home"]) return;
  try {
    
const AB_DATA=[{"id": 1, "name": "Peeling Nuit Rénovateur Éclat", "priceOurs": 485}, {"id": 2, "name": "Masque Repulpant Pro-Hyaluronic", "priceOurs": 437}, {"id": 3, "name": "Mousse Nettoyante Détox", "priceOurs": 155}, {"id": 4, "name": "Masque Charbon Détox", "priceOurs": 272}, {"id": 5, "name": "Sérum Repulpant Fondamental", "priceOurs": 582}, {"id": 6, "name": "Masque Crème Réhydratant Intense", "priceOurs": 301}, {"id": 7, "name": "Huile Démaquillante Remarquable", "priceOurs": 194}];
let abCurrent=null;
function abOpenModal(id){abCurrent=AB_DATA.find(p=>p.id===id);document.getElementById('abProductName').textContent=abCurrent.name;document.getElementById('abPrice').textContent=abCurrent.priceOurs+' MAD';document.getElementById('abFormView').style.display='';document.getElementById('abSuccess').classList.remove('show');document.getElementById('abModal').classList.add('active');document.body.style.overflow='hidden';}
function abCloseModal(){document.getElementById('abModal').classList.remove('active');document.body.style.overflow='';}
document.getElementById('abModal').addEventListener('click',function(e){if(e.target===this)abCloseModal();});
function abSubmitOrder(){const p=document.getElementById('abPrenom').value.trim(),n=document.getElementById('abNom').value.trim(),t=document.getElementById('abTel').value.trim(),v=document.getElementById('abVille').value.trim(),a=document.getElementById('abAdresse').value.trim();if(!p||!n||!t||!v||!a){alert('Veuillez remplir tous les champs.');return;}const msg=encodeURIComponent('COMMANDE ALPHABIZLABS\nProduit: '+abCurrent.name+'\nPrix: '+abCurrent.priceOurs+' MAD\nPrenom: '+p+'\nNom: '+n+'\nTel: '+t+'\nVille: '+v+'\nAdresse: '+a);window.open('https://wa.me/212779431177?text='+msg,'_blank');document.getElementById('abFormView').style.display='none';document.getElementById('abSuccess').classList.add('show');}
function abToggle(el){el.classList.toggle('open');const b=el.nextElementSibling;b.classList.toggle('open');}
(function(){let t=23*3600+59*60+59;function tick(){const h=Math.floor(t/3600),m=Math.floor((t%3600)/60),s=t%60;const eH=document.getElementById('cdH'),eM=document.getElementById('cdM'),eS=document.getElementById('cdS');if(eH)eH.textContent=String(h).padStart(2,'0');if(eM)eM.textContent=String(m).padStart(2,'0');if(eS)eS.textContent=String(s).padStart(2,'0');if(t>0){t--;setTimeout(tick,1000);}}tick();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
